document.addEventListener('DOMContentLoaded', function () {
    // Discounts
    const buy2Get10 = 0.10; // 10% for 2 bottles
    const buy3Get12 = 0.12; // 12% for 3 bottles
    const buy4Get15 = 0.15; // 15% for 4 bottles
    const buy5ormoreGet20 = 0.20; // 20% for 5 or more bottles
    const subAndSaveDisc = 0.10; // Additional 10% subscription discount

    const quantityInput = document.querySelector('input[name="quantity"]');
    if (!quantityInput) {
        console.error('Quantity input field not found.');
        return;
    }

    const twoAppstleOneTime = document.querySelector('.appstle_one_time_details_wrapper');
    const twoAppstleSubSaveTime = document.querySelector('.appstle_subscription_radio_wrapper');

    // Add event listeners for bottle buttons
    document.querySelectorAll('.qty-button').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.stopPropagation();
            if (button.id === 'one-bottle') {
                resetAll(button);
            } else if (button.id === 'two-bottles') {
                handleBottleClick(button, buy2Get10, subAndSaveDisc);
            } else if (button.id === 'four-bottles') {
                handleBottleClick(button, buy4Get15, subAndSaveDisc);
            }
        });
    });

    // Core reusable function for handling discounts
    function handleBottleClick(button, discountRate, secondaryDiscountRate) {
        const price = parseFloat(button.getAttribute('price').replace('$', '').replace(',', ''));
        const qty = parseInt(button.getAttribute('data-qty'));

        const discountPrice = price * discountRate;
        const priceAfterDiscount = price - discountPrice;
        const finalSPrice = priceAfterDiscount * secondaryDiscountRate;
        const nowThisFinal = Math.abs(finalSPrice - priceAfterDiscount);

        // Multiply with quantity
        const priceAfterDiscountQty = priceAfterDiscount * qty;
        const finalSPriceQty = nowThisFinal * qty;

        // Update UI
        console.log(`Price After Discount (Qty): $${priceAfterDiscountQty.toFixed(2)}`);
        console.log(`Final Subscription Price (Qty): $${finalSPriceQty.toFixed(2)}`);
        updateQuantity(qty);
        setActiveButton(button);

        setTimeout(() => {
            document.querySelector('.appstle_one_time_price_wrapper .appstle_subscription_amount').innerText = `$${priceAfterDiscountQty.toFixed(2)}`;
            document.querySelector('.appstle_subscription_compare_amount').innerText = `$${priceAfterDiscountQty.toFixed(2)}`;
            document.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_amount').innerText = `$${finalSPriceQty.toFixed(2)}`;
        }, 500);
    }

    // Reset all states when "one-bottle" is clicked
    function resetAll(button) {
        updateQuantity(1); // Set quantity to 1
        setActiveButton(button); // Set "one-bottle" button as active
        console.log('Resetting all states to default.');
    }

    // Update the quantity field and trigger change
    function updateQuantity(qty) {
        if (quantityInput) {
            quantityInput.value = qty;
            triggerInputChange(quantityInput);
        }
    }
  
    function triggerInputChange(input) {
        const event = new Event('change', { bubbles: true });
        input.dispatchEvent(event);
    }

    // Set active state for buttons
    function setActiveButton(activeButton) {
        document.querySelectorAll('.bottle_item').forEach((item) => {
            item.classList.remove('active');
        });
        if (activeButton) {
            activeButton.closest('.bottle_item').classList.add('active');
        }
    }

    // Generic bottle click handler for manual input
    function handleBottleClick2(mainQty, discountRate, secondaryDiscountRate) {
        const price = parseFloat(document.querySelector('#one-bottle').getAttribute('price').replace('$', '').replace(',', ''));

        const discountPrice = price * discountRate;
        const priceAfterDiscount = price - discountPrice;
        const finalSPrice = priceAfterDiscount * secondaryDiscountRate;
        const nowThisFinal = Math.abs(finalSPrice - priceAfterDiscount);

        const priceAfterDiscountQty = priceAfterDiscount * mainQty;
        const finalSPriceQty = nowThisFinal * mainQty;

        console.log(`Price After Discount (Qty): $${priceAfterDiscountQty.toFixed(2)}`);
        console.log(`Final Subscription Price (Qty): $${finalSPriceQty.toFixed(2)}`);
      
        document.querySelectorAll('.bottle_item').forEach((item) => {
            item.classList.remove('active');
        });
      
        if (mainQty == 1) {document.querySelector('.one-bottle').classList.add('active'); }
        if (mainQty == 2) {document.querySelector('.two-bottles').classList.add('active'); }
        if (mainQty == 4) { document.querySelector('.four-bottles').classList.add('active'); }
        
        setTimeout(() => {
            document.querySelector('.appstle_one_time_price_wrapper .appstle_subscription_amount').innerText = `$${priceAfterDiscountQty.toFixed(2)}`;
            document.querySelector('.appstle_subscription_compare_amount').innerText = `$${priceAfterDiscountQty.toFixed(2)}`;
            document.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_amount').innerText = `$${finalSPriceQty.toFixed(2)}`;
        }, 500);
    }

    // Handle outside body clicks
    document.body.addEventListener('click', (event) => {
        const quantityInputVal = document.querySelector('input[name="quantity"]');
        const mainQty = quantityInputVal ? parseInt(quantityInputVal.value) : 1;

        if (mainQty === 1) handleBottleClick2(mainQty, 0, subAndSaveDisc);
        if (mainQty === 2) handleBottleClick2(mainQty, buy2Get10, subAndSaveDisc);
        if (mainQty === 3) handleBottleClick2(mainQty, buy3Get12, subAndSaveDisc);
        if (mainQty === 4) handleBottleClick2(mainQty, buy4Get15, subAndSaveDisc);
        if (mainQty >= 5) handleBottleClick2(mainQty, buy5ormoreGet20, subAndSaveDisc);
    });

    // TwoAppstleOneTime click
    if (twoAppstleOneTime) {
        twoAppstleOneTime.addEventListener('click', (event) => {
            event.stopPropagation();
            handleQuantityBasedClick();
        });
    }

    // TwoAppstleSubSaveTime click
    if (twoAppstleSubSaveTime) {
        twoAppstleSubSaveTime.addEventListener('click', (event) => {
            event.stopPropagation();
            handleQuantityBasedClick();
        });
    }

    function handleQuantityBasedClick() {
        const quantityInputVal = document.querySelector('input[name="quantity"]');
        const mainQty = quantityInputVal ? parseInt(quantityInputVal.value) : 1;

        if (mainQty === 1) handleBottleClick2(mainQty, 0, subAndSaveDisc);
        if (mainQty === 2) handleBottleClick2(mainQty, buy2Get10, subAndSaveDisc);
        if (mainQty === 3) handleBottleClick2(mainQty, buy3Get12, subAndSaveDisc);
        if (mainQty === 4) handleBottleClick2(mainQty, buy4Get15, subAndSaveDisc);
        if (mainQty >= 5) handleBottleClick2(mainQty, buy5ormoreGet20, subAndSaveDisc);
    }
});



document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    // Select elements
    const productInput = document.querySelector('.product-form__input.product-form__quantity');
    const productFormButtons = document.querySelector('.product-form__buttons');
    const appstleWidget = productFormButtons.querySelector('.appstle_sub_widget');
    const productSubmit = productFormButtons.querySelector('.product-form__submit');

    // Check if all elements exist
    if (productInput && appstleWidget && productSubmit) {
        // Append product input between appstle_widget and product submit
        productFormButtons.insertBefore(productInput, productSubmit);
    } else {
        console.error("One or more elements are missing. Check the selectors.");
    }
  }, 1000);
});
